import React, { useEffect, useRef, useState } from 'react';
import AdminDialog from './AdminDialog';
import { SelectBox, TagBox, TextArea, TextBox } from 'devextreme-react';
import { useSelector } from 'react-redux';
import { selectEmailRecipients, selectTemplateTypes } from '../../redux/templates/selectors';
import { SmsFormTypeIds } from '../../Constantes/smsFormTypes';
import { makeStyles, Typography } from '@material-ui/core';
import HtmlEditor, { Toolbar, Item } from 'devextreme-react/html-editor';

const useStyles = makeStyles({
  label: {
    color: '#333',
  },
});

const initialData = {
  name: '',
  templateCode: '',
  emailSubject: '',
  templateTypeId: null,
  text: '',
  recipients: null,
  recipientsCC: null,
};

function InputWrapper(props) {
  const { classes, label } = props;
  return (
    <div className="dx-field">
      <label className={classes.label}>{label}</label>
      <div style={{ width: '75%' }} className="dx-field-value">
        {props.children}
      </div>
    </div>
  );
}

const sizeValues = ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'];
const fontValues = ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'];
const headerValues = [false, 1, 2, 3, 4, 5];
const fontSizeOptions = {
  inputAttr: {
    'aria-label': 'Font size',
  },
};
const fontFamilyOptions = {
  inputAttr: {
    'aria-label': 'Font family',
  },
};
const headerOptions = {
  inputAttr: {
    'aria-label': 'Font family',
  },
};

function TemplatesDialogue(props) {
  const { operation, data, open, handleDialogClose, onSubmitOperation } = props;
  const [editData, setEditData] = useState(initialData);
  const templateTypes = useSelector(selectTemplateTypes);
  const emailRecipients = useSelector(selectEmailRecipients);
  const classes = useStyles();
  const recipientsTagbox = useRef(null);
  const recipientsCCTagbox = useRef(null);
  const title = operation === 'create' ? 'Adicionar template' : operation === 'edit' ? 'Editar template' : 'Remover template';

  useEffect(() => {
    if (open && data) {
      setEditData(data);
    } else {
      setEditData(initialData);
    }
  }, [data, open]);

  function handleEditField(key, value) {
    const MAX_LENGTH = 1500; // Maximum allowed characters

    if (value <= MAX_LENGTH) {
      setEditData((editData) => ({ ...editData, [key]: value }));
    } else {
      // Optionally trim excess characters
      const trimmedValue = value.substring(0, MAX_LENGTH);
      setEditData((editData) => ({ ...editData, [key]: trimmedValue }));
    }

    //setEditData((editData) => ({ ...editData, [key]: value }));
  }

  function handleChangeType(value) {
    if (value !== SmsFormTypeIds.internal_email) {
      handleEditField('recipients', null);
      handleEditField('recipientsCC', null);
      recipientsTagbox.current?.instance?.reset();
      recipientsCCTagbox.current?.instance?.reset();
    }
    if (value === SmsFormTypeIds.sms) {
      handleEditField('subject', '');
    }
    handleEditField('templateTypeId', value);
  }

  function handleChangeRecipients(value) {
    const updatedValues = value.length > 0 ? value : [];
    handleEditField('recipients', updatedValues);
  }

  function handleChangeRecipientsCC(value) {
    const updatedValues = value.length > 0 ? value : [];
    handleEditField('recipientsCC', updatedValues);
  }

  const customItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;
      return;
    }
    args.customItem = { emailRecipientId: 0, emailAddress: args.text };
  };

  const [isMultiline, setIsMultiline] = useState(true);
  //const [currentTab, setCurrentTab] = useState(tabs[2].value);

  //   const multilineChanged (
  //     (e) => {
  //       setIsMultiline(e.value);
  //     },
  //     [setIsMultiline],
  //   );

  //   const currentTabChanged = useCallback(
  //     (e) => {
  //       setCurrentTab(e.value);
  //     },
  //     [setCurrentTab],
  //   );

  return (
    <AdminDialog dialogSize={{ height: '100%' }} operation={operation} open={open} onClose={handleDialogClose} title={title} data={editData} handleOnClick={() => onSubmitOperation(editData)}>
      {operation === 'delete' ? (
        <Typography>{`O template ${editData.name} será removido.`}</Typography>
      ) : (
        <>
          <InputWrapper classes={classes} label={'Tipo'}>
            <SelectBox
              dataSource={data?.templateId == null ? templateTypes?.filter(to => to.code !== 'custom_email') : templateTypes}
              disabled={editData.templateTypeId === 1} // 1 == custom_email
              value={editData.templateTypeId}
              displayExpr={'description'}
              valueExpr={'id'}
              onValueChanged={(e) => handleChangeType(e.value)}
              searchEnabled={true}
              showClearButton={false}
            ></SelectBox>
          </InputWrapper>
          <InputWrapper classes={classes} label={'Nome'}>
            <TextBox
              height={35}
              value={editData.name}
              onValueChanged={(e) => {
                handleEditField('name', e.value);
              }}
            />
          </InputWrapper>

          <InputWrapper classes={classes} label={'Assunto'}>
            <TextBox
              disabled={editData.templateTypeId === SmsFormTypeIds.sms}
              height={35}
              value={editData.subject}
              onValueChanged={(e) => {
                handleEditField('subject', e.value);
              }}
            />
          </InputWrapper>

          {editData.templateTypeId == null || editData.templateTypeId === 4 /*SMS*/ ? (
            <InputWrapper classes={classes} label={'Mensagem'}>
              <TextArea
                height={100}
                minHeight={35}
                value={editData.text}
                onValueChanged={(e) => {
                  handleEditField('text', e.value);
                }}
              />
            </InputWrapper>
          ) : (
            <InputWrapper classes={classes} label={'Mensagem'}>
              <HtmlEditor
                height="300px"
                maxlength="1500"
                value={editData.text}
                onValueChanged={(e) => {
                  handleEditField('text', e.value);
                }}
              >
                <Toolbar multiline={isMultiline}>
                  {/* <Item name="undo" />
                <Item name="redo" />
                <Item name="separator" /> */}
                  <Item name="size" acceptedValues={sizeValues} options={fontSizeOptions} />
                  <Item name="font" acceptedValues={fontValues} options={fontFamilyOptions} />
                  <Item name="separator" />
                  <Item name="bold" />
                  <Item name="italic" />
                  <Item name="strike" />
                  <Item name="underline" />
                  <Item name="separator" />
                  <Item name="alignLeft" />
                  <Item name="alignCenter" />
                  <Item name="alignRight" />
                  {/* <Item name="alignJustify" /> */}
                  <Item name="separator" />
                  <Item name="orderedList" />
                  <Item name="bulletList" />
                  {/* <Item name="separator" />
                <Item name="header" acceptedValues={headerValues} options={headerOptions} />
                  <Item name="separator" />
                  <Item name="color" />
                  <Item name="background" />
                <Item name="separator" />
                <Item name="link" />
                <Item name="image" />
                <Item name="separator" />
                <Item name="clear" />
                <Item name="codeBlock" />
                <Item name="blockquote" />
                <Item name="separator" />
                <Item name="insertTable" />
                <Item name="deleteTable" />
                <Item name="insertRowAbove" />
                <Item name="insertRowBelow" />
                <Item name="deleteRow" />
                <Item name="insertColumnLeft" />
                <Item name="insertColumnRight" />
                <Item name="deleteColumn" /> */}
                </Toolbar>
              </HtmlEditor>
            </InputWrapper>
          )}

          <InputWrapper classes={classes} label={'Destinatários'}>
            <TagBox
              ref={recipientsTagbox}
              // disabled={editData.templateTypeId !== SmsFormTypeIds.internal_email}
              dataSource={emailRecipients}
              showClearButton={true}
              defaultValue={editData.recipients?.map((r) => r.emailAddress) || null}
              displayExpr={'emailAddress'}
              valueExpr={'emailAddress'}
              onValueChanged={(e) => {
                handleChangeRecipients(e.value);
              }}
              searchEnabled={true}
              hideSelectedItems
              acceptCustomValue
              onCustomItemCreating={customItemCreating}
            />
          </InputWrapper>
          <InputWrapper classes={classes} label={'Destinatários CC'}>
            <TagBox
              ref={recipientsCCTagbox}
              // disabled={editData.templateTypeId !== SmsFormTypeIds.internal_email}
              dataSource={emailRecipients}
              showClearButton={true}
              defaultValue={editData.recipientsCC?.map((rcc) => rcc.emailAddress) || null}
              displayExpr={'emailAddress'}
              valueExpr={'emailAddress'}
              onValueChanged={(e) => {
                handleChangeRecipientsCC(e.value);
              }}
              searchEnabled={true}
              hideSelectedItems
              acceptCustomValue
              onCustomItemCreating={customItemCreating}
            />
          </InputWrapper>
        </>
      )}
    </AdminDialog>
  );
}

export { TemplatesDialogue };
